import { useMemo } from 'react';
import { uniqWith, toLower, filter } from 'lodash';

import { APPROVAL_TYPE, isNegativeType } from 'src/data/brandTerm';

const sameText = (str1, str2) => toLower(str1) === toLower(str2);

const isSimilarItem = (item1, item2) => {
  const brandTerm1 = item1?.brandTerm;
  const brandTerm2 = item2?.brandTerm;

  if (brandTerm1?.approvalType === brandTerm2?.approvalType) {
    if (brandTerm1?.approvalType === APPROVAL_TYPE.approved) {
      return sameText(item1.termInText, item2.termInText);
    }
    if (isNegativeType(brandTerm1?.approvalType)) {
      return (
        sameText(item1.termInText, item2.termInText) &&
        sameText(brandTerm1?.replaceWith, brandTerm2?.replaceWith)
      );
    }
  }

  return false;
};

//returns terms of negative APPROVAL_TYPE
export const usePrepareDetectedBrandTerms = (detectedBrandTermsData) => {
  const items = detectedBrandTermsData?.items;
  const loading = detectedBrandTermsData?.loading || false;

  const preparedItems = useMemo(() => {
    const itemsTypeDontUse = filter(items, ({ brandTerm }) =>
      isNegativeType(brandTerm.approvalType)
    );

    if (!itemsTypeDontUse) {
      return [];
    }

    return uniqWith(itemsTypeDontUse, isSimilarItem);
  }, [items]);

  return {
    items: preparedItems,
    loading,
  };
};
